<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description : 富文本编辑器
  -->
  <div class="editor" v-loading="loading">
    <div ref="toolbar" class="toolbar"></div>
    <div ref="editor" class="text"></div>
  </div>
</template>

<script>
import E from "wangeditor";
import OSS from "ali-oss";
import { uploadCover } from "@/api/upload";
export default {
  name: "gaia-editor",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    isClear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editor: null,
      info_: null,
      resourcesUrl: process.env.VUE_APP_RESOURCES_URL,
      loading: false,
    };
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear();
        this.info_ = null;
      }
    },
    value(value) {
      if (value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value);
      }
    },
  },
  mounted() {
    this.seteditor();
    this.editor.txt.html(this.value);
  },
  methods: {
    seteditor() {
      const that = this;
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);
      this.editor.config.uploadImgMaxSize = 5 * 1024 * 1024; // 将图片大小限制为 5M
      this.editor.config.uploadImgMaxLength = 1; // 限制一次最多上传 3 张图片
      this.editor.config.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间

      // 配置菜单
      this.editor.config.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
        "fullscreen", // 全屏
      ];
      /* 自定义图片上传（支持跨域和非跨域上传，简单操作）*/

      this.editor.config.customUploadImg = async (file, insert) => {
        this.loading = true;
        file = file[0];
        this.fileList = [];
        const name = file.name;
        const data = {
          fileFormat: name.split(".")[name.split(".").length - 1],
          sts: true,
          type: "cover",
        };
        uploadCover(data)
          .then(({ uploadToken }) => {
            const fileName = uploadToken.dir + uploadToken.fileName;
            const ossConfig = {
              region: "oss-cn-hangzhou",
              accessKeyId: uploadToken.accessKeyId,
              accessKeySecret: uploadToken.accessKeySecret,
              stsToken: uploadToken.signature,
              bucket: uploadToken.bucket,
            };
            const client = new OSS(ossConfig);
            client
              .multipartUpload(fileName, file, {
                progress: (p) => {
                  this.progress = parseInt(p * 100);
                },
              })
              .then(
                (res) => {
                  this.$message.success("图片上传成功");
                  insert(this.resourcesUrl + fileName);
                  this.loading = false;
                },
                (err) => {
                  this.$message.error("oss上传失败");
                  console.log("err", err);
                  this.loading = false;
                }
              );
          })
          .catch((res) => {
            console.log(res);
            this.$message.error("上传接口调用失败");
            this.loading = false;
          });

        /* upload方法是后台提供的上传图片的接口 */
        /* insert 是编辑器自带的 获取图片 url 后，插入到编辑器的方法 上传代码返回结果之后，将图片插入到编辑器中*/
      };
      this.editor.config.onchange = (html) => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
      };
      // 创建富文本编辑器
      this.editor.create();
    },
  },
};
</script>

<style lang="less" scoped>
.editor {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 0;
}
.toolbar {
  border: 1px solid #ccc;
}
.text {
  border: 1px solid #ccc;
  min-height: 500px;
}
</style>